var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ fadeOut: _vm.refreshing },attrs:{"id":"app"}},[_c('router-view'),_c('loading-screen-component'),(_vm.isFooterVisible)?_c('footer-component'):_vm._e(),(_vm.isPopuperVisible)?_c('popup-component'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }